import { HttpTransportType, HubConnectionBuilder } from "@microsoft/signalr";
import { baseUrl } from "../utilities/configurations";
import { useAuth } from "./AuthContext";
import PropTypes from "prop-types";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";

const SignalRContext = createContext();

export function useSignalR() {
  return useContext(SignalRContext);
}
export function SignalRProvider(props) {
  const [notifications, setNotifications] = useState([]);
  const [hasNewNotif, setHasNewNotif] = useState(false);
  const [connection, setConnection] = useState(null);
  const { isAuthenticated, token } = useAuth();

  useEffect(() => {
    if (isAuthenticated && token) {
      setNotifications([]);
      setHasNewNotif(false);
      const newConnection = new HubConnectionBuilder()
        .withUrl(baseUrl + "/notifications", {
          accessTokenFactory: () => token.accessToken,
          transport: HttpTransportType.WebSockets,
          skipNegotiation: true,
        })
        .withAutomaticReconnect()
        .build();

      newConnection
        .start()
        .then(() => {
          return newConnection.invoke("Subscribe");
        })
        .then(() => {
          console.log("Connected to SignalR hub and subscribed.");
          return newConnection.invoke("GetNotifications");
        })
        .catch((err) => {
          console.error("Error:", err);
        });

      newConnection.on("ReceiveNotification", (newNotif) => {
        setNotifications((prevNotifications) => [
          newNotif,
          ...prevNotifications,
        ]);
        if(!newNotif.isRead){
          setHasNewNotif(true);
        }
      });

      setConnection(newConnection);

      return () => {
        newConnection.stop();
      };
    }
  }, [isAuthenticated, token]);

  const invokeMethod = useCallback(
    (methodName, ...params) => {
      if (connection) {
        return connection.invoke(methodName, ...params);
      } else {
        return Promise.reject(new Error("Connection not established"));
      }
    },
    [connection]
  );

  const data = useMemo(
    () => ({
      setNotifications,
      invokeMethod,
      setHasNewNotif,

      notifications,
      hasNewNotif
    }),
    [notifications, hasNewNotif]
  );

  return (
    <SignalRContext.Provider value={data}>
      {props.children}
    </SignalRContext.Provider>
  );
}

SignalRProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
